import styled from '@emotion/styled';
import { useState } from 'react';

import { Dots } from './Dots';
import { Slide } from './Slide';

interface CarouselProps {
  imagesUrls: string[];
}

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
`;

export const Carousel = ({ imagesUrls }: CarouselProps): JSX.Element | null => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const onSlideChange = (direction: 'left' | 'right') => {
    if (direction === 'left') {
      setCurrentSlideIndex(currentSlideIndex === 0 ? imagesUrls.length - 1 : currentSlideIndex - 1);
    } else {
      setCurrentSlideIndex(currentSlideIndex === imagesUrls.length - 1 ? 0 : currentSlideIndex + 1);
    }
  };

  const onDotChange = (index: number) => {
    setCurrentSlideIndex(index);
  };

  return imagesUrls.length ? (
    <CarouselContainer>
      <Slide
        imageUrl={imagesUrls[currentSlideIndex]}
        onChange={onSlideChange}
        isFirstElement={false}
        isLastElement={false}
      />
      <Dots images={imagesUrls} currentIndex={currentSlideIndex} onClick={onDotChange} />
    </CarouselContainer>
  ) : null;
};
